import { useEffect, useState } from 'react';

export const useIsMobile = (breakpoint = 450): { isMobile: boolean } => {
  const [isMobile, setIsMobile] = useState(window.innerWidth < breakpoint);

  useEffect(() => {
    const updateIsMobile = () => {
      setIsMobile(window.innerWidth < breakpoint);
    };

    updateIsMobile();
    window.addEventListener('resize', updateIsMobile);

    return () => {
      window.removeEventListener('resize', updateIsMobile);
    };
  }, [breakpoint]);

  return {
    isMobile,
  };
};
